import type { ReturnReason, Shop } from "../types";

export function getReturnReasons(shop: Shop, lang = "fr"): ReturnReason[] {
  const reasons = (shop as any).reasons ?? [];

  return reasons
    .filter((r: any) => r.active !== false)
    .map((r: any): ReturnReason => {
      const label =
        r.values?.find((v: any) => v.lang === lang)?.text ??
        r.values?.[0]?.text ??
        r.id;

      return {
        id: r.id,
        label,
        requiresComment: r.rules?.comment?.required ?? false,
        requiresPhoto: r.rules?.photoRequired?.required ?? false,
        commentAvailable: r.rules?.comment?.available ?? true,
        photoAvailable: r.rules?.photoRequired?.available ?? true,
        isRetractation: r.babackStandardReason === "RETRACTION",
      };
    });
}
